/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-03 15:52:07
 * @Description:
 */
import CTAButton from '../CTAButton';

function Fallback() {
  const handleBack = () => {
    location.replace(`${location.origin}`);
  };
  return (
    <div className="h-full flex flex-col items-center justify-center gap-4 px-4">
      <div className="text-lg text-black font-bold">Sorry</div>
      <div className="text-base text-center">
        Kesalahan jaringan, silakan segarkan lagi.
      </div>
      <CTAButton text="Muat ulang" onClick={handleBack} />
    </div>
  );
}

export default Fallback;
